class UsersTabs {
  constructor() {

  }

  init() {

    const tabs = document.querySelectorAll(".users-tabs__tab");
    const tabContent = document.querySelectorAll(".users-tabs__content");

    if(tabs !== null ) {

      tabs.forEach((tab, i) => {
        tab.addEventListener("click", function () {
          tabs.forEach(tab => tab.classList.remove("active"));
          this.classList.add("active");
          tabContent.forEach(content => content.classList.add("hidden"));
          tabContent[i].classList.remove("hidden");
        });
      });
    }

  }
}

export default new UsersTabs();



